import { CuroApplicationVariables } from 'enums/curo/Variables';
import { VariableValue } from 'product_modules/api/Types';

export enum ApplicationStatuses {
  NewApplication = 'NewApplication',
  ManualReview = 'ManualReview',
  ManuallyApproved = 'ManuallyApproved',
  AutoApproved = 'AutoApproved',
  Approved = 'Approved',
  SentForFunding = 'SentForFunding',
  FundingFailed = 'FundingFailed',
  Abandon = 'Abandon',
  Funded = 'Funded',
  Decline = 'Decline',
}

export interface ICuroApplication {
  createdAt: string;
  id: string;
  variables: Record<CuroApplicationVariables, VariableValue>;
  status: ApplicationStatuses;
  declineReasons: string[];
}
